module.exports = __webpack_public_path__ + "static/a-xx-036-art-9d58dc991aca0eed36e6986f3dd1eb04.jpg";